import { useState } from 'react';
import type { Faq } from '@/mocks/faqs';

interface FaqAccordionProps {
  items: Faq[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(items[0]?.id ?? null);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpenId(isOpen ? null : item.id)}
                className="flex w-full cursor-pointer items-start justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
              >
                <span className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {item.question}
                </span>
                <span
                  className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? 'bg-primary-600 text-background-50' : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-base`} />
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-5 pb-6 md:px-6">
                <p className="max-w-3xl text-sm leading-relaxed text-foreground-700">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}